import { render, staticRenderFns } from "./LocalGroup.vue?vue&type=template&id=2f5c4a80&scoped=true&"
import script from "./LocalGroup.vue?vue&type=script&lang=ts&"
export * from "./LocalGroup.vue?vue&type=script&lang=ts&"
import style0 from "./LocalGroup.vue?vue&type=style&index=0&id=2f5c4a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c4a80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VTextField})
